import { render, staticRenderFns } from "./OffersTable.vue?vue&type=template&id=939db576"
import script from "./OffersTable.vue?vue&type=script&lang=ts"
export * from "./OffersTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports